'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FormInput = require('../fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FieldValidationMessages = require('../../../components/form/validation/FieldValidationMessages');

var _FieldValidationMessages2 = _interopRequireDefault(_FieldValidationMessages);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _LinkButton = require('../../buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _FieldRow = require('../formatting/FieldRow');

var _FieldRow2 = _interopRequireDefault(_FieldRow);

var _Field = require('../formatting/Field');

var _Field2 = _interopRequireDefault(_Field);

var _creditCardFormatters = require('./creditCardFormatters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCard = function CreditCard(props) {
    var sanitisedErrors = props.sanitisedErrors,
        fields = props.fields,
        dispatchClearCard = props.dispatchClearCard;


    var disabled = !!fields.cardPrefilled.value;

    return _react2.default.createElement(
        _Fieldset2.default,
        _extends({}, props, { name: 'CreditCard' }),
        _react2.default.createElement(
            'div',
            { className: 'form-header' },
            _react2.default.createElement(
                'legend',
                null,
                'Credit card details'
            ),
            fields.cardPrefilled.value ? _react2.default.createElement(
                _LinkButton2.default,
                { onClickFn: dispatchClearCard },
                'Edit'
            ) : null,
            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.number }),
            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.expiry }),
            _react2.default.createElement(_FieldValidationMessages2.default, { sanitisedError: sanitisedErrors.cvc })
        ),
        _react2.default.createElement(
            _FieldRow2.default,
            null,
            _react2.default.createElement(
                _Field2.default,
                { className: 'name' },
                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                    name: fields.cardName.name,
                    type: 'text',
                    className: 'cc-name',
                    id: 'cardHolder',
                    autoComplete: 'cc-name',
                    placeholder: 'Name on card',
                    noName: true,
                    noValidate: true,
                    disabled: disabled }))
            )
        ),
        _react2.default.createElement(
            _FieldRow2.default,
            null,
            _react2.default.createElement(
                _Field2.default,
                { className: (0, _classnames2.default)('card-number', (0, _creditCardFormatters.getCardType)(fields.number.value), fields.cardBrand.value) },
                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                    name: fields.number.name,
                    type: 'text',
                    className: 'cc-number',
                    id: 'cardNumber',
                    autoComplete: 'cc-number',
                    placeholder: 'Card number',
                    pattern: '\\d*',
                    noName: true,
                    noValidate: true,
                    valueFormatter: _creditCardFormatters.numberFormatter,
                    disabled: disabled }))
            )
        ),
        _react2.default.createElement(
            _FieldRow2.default,
            null,
            _react2.default.createElement(
                _Field2.default,
                { className: 'expiry' },
                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                    name: fields.expiry.name,
                    type: 'text',
                    id: 'cardExpiration',
                    className: 'cc-exp',
                    autoComplete: 'cc-exp',
                    placeholder: 'MM / YY',
                    pattern: '\\d*',
                    noName: true,
                    noValidate: true,
                    valueFormatter: _creditCardFormatters.expiryFormatter,
                    disabled: disabled }))
            ),
            _react2.default.createElement(
                _Field2.default,
                { className: 'cvc' },
                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                    name: fields.cvc.name,
                    type: 'text',
                    id: 'cardCsc',
                    className: 'cc-cvc',
                    autoComplete: 'off',
                    placeholder: 'CVC',
                    pattern: '\\d*',
                    noName: true,
                    noValidate: true,
                    valueFormatter: _creditCardFormatters.cvcFormatter,
                    disabled: disabled }))
            )
        ),
        !disabled ? _react2.default.createElement(
            _FieldRow2.default,
            null,
            _react2.default.createElement(
                _Field2.default,
                null,
                _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                    name: fields.postcode.name,
                    type: 'text',
                    id: 'frmZipS',
                    placeholder: 'ZIP / Postcode',
                    disabled: disabled,
                    maxLength: 16,
                    autocomplete: 'shipping postal-code' }))
            )
        ) : null
    );
};

CreditCard.propTypes = {
    fields: _propTypes2.default.object,
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object,
    primaryError: _propTypes2.default.object,
    dirtySinceSubmission: _propTypes2.default.bool,
    customer: _propTypes2.default.object,
    dispatchClearCard: _propTypes2.default.func
};

exports.default = CreditCard;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/CreditCard.js
// module id = 1772
// module chunks = 0